import classNames from "classnames";
import React from "react";
import PanelSegmentType from "./PanelSegment/PanelSegment";

interface Props {
  title?: string | React.ReactNode
}

const OptionsPanel = (props: React.PropsWithChildren<Props>) => {
  const { title } = props;

  const classes = classNames("s1_options-panel");

  return (<div className={classes}>
    {(title) && <PanelSegmentType>
      <PanelSegmentType.Header size="h2">
        <PanelSegmentType.Title title={title} />
      </PanelSegmentType.Header>
    </PanelSegmentType>}

    {props.children}
  </div>);
};

export default OptionsPanel;